import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import logo from "../../icons/firstocklogo.svg";
import { useLocation, useNavigate } from "react-router-dom";

const pages = ["SignUp", "Docs", "Forum"];
const settings = ["Profile", "Account", "Dashboard", "Logout"];

function Header() {
  const navigate = useNavigate();
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const [isVisible, setisVisible] = React.useState(false);

  console.log(window.pageYOffset);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (page: any) => {
    if (page === "Docs") {
      // window.open(
      //   "https://connect.thefirstock.com/docsv3/docs/get-started/packages-instalation/",
      //   "_blank"
      // );
      window.open("https://wikiconnect.thefirstock.com/","_blank")
      //navigate("docsv3");
    }
    if (page === "SignUp") {
      window.open("https://signup.thefirstock.com/", "_blank");
    }
    if (page === "Forum") {
      window.open("https://community.thefirstock.tech/", "_blank");
    }
    setAnchorElNav(null);
  };

  const handleNavigate = () => {
    navigate("/login");
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const toggleVisibility = () => {
    if (window.pageYOffset > 550) {
      setisVisible(true);
    } else {
      setisVisible(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <AppBar
      // position={!isVisible ? "sticky" : "fixed"}
      position="relative"
      sx={{
        // backgroundImage: !isVisible
        //   ? "linear-gradient(to right, #c1cee1, #FFFFFF)"
        //   : "linear-gradient(to right,#FFFFFF , #FFFFFF)",
        background: "transparent",
        boxShadow: "none",
        transition: "0.3s ease-in-out",
        zIndex: 100,
        // height: "80px",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          boxShadow: { xs: "2px 2px 2px 1px rgba(0, 0, 0, 0.2)", md: "none" },
        }}
      >
        <Toolbar
          disableGutters
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <img
            src={logo}
            alt="logo"
            style={{ height: "60px", width: "100px", marginLeft: "20px" }}
          />

          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              sx={{ color: "black" }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
          
              {pages.map((page) => (
                <MenuItem
                  key={page}
                  onClick={() => {
                    handleCloseNavMenu(page);
                  }}
                >
                  <Typography textAlign="center" fontFamily="Inter">
                    {page}
                  </Typography>
                </MenuItem>
              ))}
                  <div>
                <Button
                  sx={{
                    my: 2,
                    fontWeight: "600",
                    color: "white",
                    fontfamily: "Inter",
                    display: "block",
                    bgcolor: "#6D00FF",
                    margin:"0px 10px",
                    padding: "10px 20px",
                    borderRadius: "10px",
                    textTransform: "none",
                    "&:hover": {
                      bgcolor: "#6D00FF",
                    },
                  }}
                  onClick={handleNavigate}
                >
                  Generate Key
                </Button>
              </div>
            </Menu>
          </Box>

          <Box
            sx={{
              flexGrow: 0,
              display: { xs: "none", md: "flex" },
              alignItems: "center",
            }}
          >
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => {
                  handleCloseNavMenu(page);
                }}
                sx={{
                  my: 2,
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "black",
                  display: "block",
                  margin: "0px 10px",
                  // height: "20px",
                  textTransform: "none",
                }}
              >
                {page}
              </Button>
            ))}
            <Button
              sx={{
                my: 2,
                fontWeight: "600",
                color: "white",
                fontfamily: "Inter",
                display: "block",
                bgcolor: "#6D00FF",
                padding: "10px 20px",
                borderRadius: "10px",
                textTransform: "none",
                "&:hover": {
                  bgcolor: "#6D00FF",
                },
              }}
              onClick={handleNavigate}
            >
              Generate Key
            </Button>
          </Box>

          {/* <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box> */}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Header;
